import moment from 'moment'

import { CostCenterAssignment, FormattedAssignment } from './types'

export const formatAssignments = (
  assignments: CostCenterAssignment[],
  hasNewStructureEnabled = false
): FormattedAssignment[] => {
  return assignments.map((assignment) => {
    // Base formatted assignment
    const costCenter = assignment.costCenter
    const workplaceCostCenter = assignment.workplaceCostCenter
    const jobCatalogCostCenter = assignment.jobCatalogCostCenter

    const name = costCenter?.name ?? workplaceCostCenter?.name ?? jobCatalogCostCenter?.name ?? ''

    // Format cost center names with code if available
    const formatCostCenterName = (
      cc: { code?: string | null; name: string } | null | undefined
    ) => {
      if (!cc) return undefined
      return cc.code ? `${cc.code} - ${cc.name}` : cc.name
    }

    const formatted: FormattedAssignment = {
      name,
      id: String(assignment.id),
      percentage: assignment.percentage,
      startDate: assignment.startDate,
      endDate: assignment.endDate ?? undefined,
      costCenterId: hasNewStructureEnabled ? undefined : assignment.costCenter?.id,
      isDefault: assignment.isDefault ?? false,
      workplaceCostCenterId: assignment.workplaceCostCenter?.id,
      workplaceCostCenterName: formatCostCenterName(workplaceCostCenter),
      jobCatalogCostCenterId: assignment.jobCatalogCostCenter?.id,
      jobCatalogCostCenterName: formatCostCenterName(jobCatalogCostCenter),
    }

    return formatted
  })
}

/**
 * Determines whether an assignment is in the future.
 * Future: startDate is strictly after today.
 * Current: startDate is today or in the past, and endDate is today or in the future (or null).
 * Past: endDate is strictly before today.
 *
 * Only future assignments should allow deletion in structured mode.
 */
export const isFutureAssignment = (startDate: string): boolean => {
  return moment(startDate).isAfter(moment(), 'day')
}
